import { SURVEY_LIST, SELECTED_SURVEY, SHOW_BACK_SCREEN } from '../actions';

export const surveyRecord = (state = {}, action) => {
  if (action.type === SURVEY_LIST) return action.payload;
  return state;
};

export const selectedSurvey = (state = {}, action) => {
  if (action.type === SELECTED_SURVEY) return action.payload;
  return state;
};

export const showBackSurvey = (state = {}, action) => {
  if (action.type === SHOW_BACK_SCREEN) return action.payload;
  return state;
};
